function snap(options) {

	// Options Parameters
	const config = $.extend({
		button: {},
		buttons: [],
		message: 'Alerta!!'
	}, options);

	if (typeof options == 'string' && options != '') {
		config.message = options;
	}

	let data = {};

	data.body = $('body');
	data.identifier = Math.floor(Math.random() * (99999 - 1)) + 1;
	data.html = ``;
	data.button_one = {};
	data.button_two = {};
	data.button_simple = {};

	data.closeSnap = function () {
		data.snap.removeClass('is--active');
		data.body.css({ 'overflow': 'auto' });
	}

	data.openSnap = function () {
		data.snap.addClass('is--active');
		data.body.css({ 'overflow': 'hidden' });
	}

	data.previewPage = function () {
		window.history.back();
	}

	if (Object.entries(config.button).length > 0) {
		config.buttons = [];
	}
	
	
	if (config.buttons.length > 2) {
		console.error('snap > max length buttons: 2');
		return false;
	}


	data.html = `
		<div id="snap-${data.identifier}" class="snap${(config.buttons.length > 0 || config.buttons == true) ? ' snap--lg' : ''}">
			<div class="snap__wrapper">
				<p class="snap__text">${config.message}</p>
				<div class="snap__button">
	`;

	if (config.buttons.length > 0) {
		config.buttons.forEach((button, index, array) => {
			if (index == 0) {
				if (button.text != undefined && button.text != '') {
					data.button_one.text = button.text;
				} else {
					data.button_one.text = 'VOLVER';
				}

				if (typeof button.click == 'function') {
					data.button_one.event = button.click;
				} else {
					if (config.buttons.length == 1) {
						data.button_one.event = data.closeSnap;
					} else {
						data.button_one.event = data.previewPage;
					}
				}

				data.html += `<button class="button button--white button--ms button--upper" data-snap="button-one"></button>`;
			} else {
				if (button.text != undefined && button.text != '') {
					data.button_two.text = button.text;
				} else {
					data.button_two.text = 'SALIR';
				}

				if (typeof button.click == 'function') {
					data.button_two.event = button.click;
				} else {
					data.button_two.event = data.closeSnap;
				}

				data.html += `<button class="button button--transparent button--ms button--upper" data-snap="button-two"></button>`;
			}
		});
	} else if (config.buttons == true) {
		data.button_one.text = 'VOLVER';
		data.button_two.text = 'SALIR';

		data.button_one.event = data.previewPage;
		data.button_two.event = data.closeSnap;

		data.html += `<button class="button button--white button--ms button--upper" data-snap="button-one"></button>`;
		data.html += `<button class="button button--transparent button--ms button--upper" data-snap="button-two"></button>`;
	} else {
		if (Object.entries(config.button).length > 0) {
			if (config.button.text != undefined && config.button.text != '') {
				data.button_simple.text = config.button.text;
			} else {
				data.button_simple.text = 'VOLVER';
			}

			if (typeof config.button.click == 'function') {
				data.button_simple.event = config.button.click;
			} else {
				data.button_simple.event = data.closeSnap;
			}
			
			data.html += `<button class="button button--white button--ms button--upper" data-snap="button-simple"></button>`;
		} else {
			data.button_simple.event = data.closeSnap;
			data.html += `<button class="button button--white button--ms button--upper" data-snap="button-simple">VOLVER</button>`;
		}
	}

	data.html += `
			</div>
		</div>
	`;

	data.body.append(data.html);

	data.snap = $(`#snap-${data.identifier}`);
	data.button_one.this = data.snap.find('[data-snap="button-one"]');
	data.button_two.this = data.snap.find('[data-snap="button-two"]');
	data.button_simple.this = data.snap.find('[data-snap="button-simple"]');

	data.button_one.this.html(data.button_one.text);
	data.button_two.this.html(data.button_two.text);
	data.button_simple.this.html(data.button_simple.text);

	data.button_one.this.on('click', data.button_one.event);
	data.button_two.this.on('click', data.button_two.event);
	data.button_simple.this.on('click', data.button_simple.event);

	data.openSnap();
}